module.exports = __webpack_public_path__ + "OpenSans-Italic.9b30f13428e1b4a659ae.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Italic/OpenSans-Italic.ttf
// module id = ../../../../npm-font-open-sans/fonts/Italic/OpenSans-Italic.ttf
// module chunks = styles